import fwUrlUtils from "../utils/fwUrlUtils";

export default {
    SEARCH_INVOICES: fwUrlUtils.getApiUrl("/webapi/invoices/search")
}
